// extracted by mini-css-extract-plugin
export default {"rightPanelContainer":"RightPanel_rightPanelContainer__In-OE","contentLayer":"RightPanel_contentLayer__YGd+x","scrollable-container":"RightPanel_scrollable-container__LRwst"};